import PropTypes from 'prop-types';
import cn from 'classnames';
import React, { useCallback } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { Link, useParams } from 'react-router-dom';

import { useBreakpoints, IconButton } from '@mssgme/ui';

import Contact from './Contact';
import useMessagesHeader from './useMessagesHeader';

import styles from './MessagesHeader.scss';
import ArchiveToggle from './ArchiveToggle';

PureMessagesHeader.propTypes = {
    isArchivedConversation: PropTypes.bool,
    contact: PropTypes.shape(Contact.propTypes).isRequired,
    openClientCard: PropTypes.func,
    onArchiveToggle: PropTypes.func,
};

export function PureMessagesHeader({ isArchivedConversation, contact, onArchiveToggle, openClientCard, children }) {
    const { isMobile } = useBreakpoints();

    const handleContactClick = useCallback(
        (e) => {
            e.preventDefault();
            openClientCard && openClientCard();
        },
        [openClientCard]
    );

    return (
        <header className={styles.root}>
            {isMobile && (
                <IconButton as={Link} to="/i" className={styles.backBtn}>
                    <IoIosArrowBack size={24} />
                </IconButton>
            )}
            <Contact onClick={isMobile ? handleContactClick : null} name={contact.name} avatarUrl={contact.avatarUrl} />
            <div className={styles.content}>{children}</div>
            <div className={cn(styles.buttons)}>
                <ArchiveToggle isActive={isArchivedConversation} onToggle={onArchiveToggle} />
            </div>
        </header>
    );
}

export default function MessagesHeader(props) {
    const { contactId } = useParams();
    const state = useMessagesHeader(contactId);

    return <PureMessagesHeader {...state} {...props} />;
}
